import styled from 'styled-components'
import arrowDown from '../../../../../assets/certificates/AddParameter/arrow-down.svg'

export const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  column-gap: 1rem;
  row-gap: 1rem;
  width: 100%;
  padding: 1rem;
  background-color: #fff;
  border-radius: 0.73rem;
`

export const InputDiv = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  flex-direction: column;
  width: 100%;

  .redBorder {
    border: #FF0000 1px solid;
  }

  .empty {
    border: 0;
  }
`

export const InputLabel = styled.label`
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: clamp(0.75rem, calc(0.75rem + 0.1vw), 1.5rem);
`

export const Input = styled.input`
  height: 2.3rem;
  background-color: #EBEBEB;
  border: 0;
  border-radius: 1.84rem;
  padding: 0 .9rem;

  :focus {
    outline: 0;
  }
`

export const MediumInput = styled.input`
  height: 2.3rem;
  background-color: #EBEBEB;
  border: 0;
  border-radius: 1.84rem;
  margin-top: 0.36rem;
  padding-left: 0.92rem;
  padding-right: 0.92rem;

  :focus {
    outline: 0;
  }
`

export const SmallInputContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: .4rem;
`

export const SmallInput = styled.input`
  height: 2.3rem;
  background-color: #EBEBEB;
  border: 0;
  border-radius: 1.84rem;
  margin-top: 0.36rem;
  padding-left: 0.92rem;
  padding-right: 0.92rem;

  :focus {
    outline: 0;
  }
`

export const StyledSelect = styled.select`
  position: relative;
  bottom: 1px;
  background-color: #ebebeb;
  color: #777777;
  height: 2.3rem;
  width: 100%;
  border: 0;
  border-radius: 1.84rem;
  margin-top: 0.36rem;
  padding-left: 0.92rem;
  padding-right: 0.92rem;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-image: url(${arrowDown});
  background-repeat: no-repeat;
  background-position-x: 97%;
  background-position-y: 0.75rem;
  background-size: 18px 15px;

  :focus{
    outline: 0;
  }
`

export const StyledOption = styled.option`
  background-color: #fff;
  height: 1vh;
  font-size: 0.8rem;
`
